import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Tabs,
  Tab,
} from "@heroui/react";
import { FillDocumentTemplate } from "shared/components/generateDocument/fillDocumentTemplate";

interface GenerateDocumentModalProps {
  isOpen: boolean;
  onOpenChange: (value: boolean) => void;
}

export const GenerateDocumentModal = ({
  isOpen,
  onOpenChange,
}: GenerateDocumentModalProps) => {
  return (
    <>
      <Modal
        radius="md"
        size="full"
        className="z-50 p-8 font-normal text-neutral-primary"
        isOpen={isOpen}
        onOpenChange={onOpenChange}
      >
        <ModalContent style={{ overflowY: "auto" }} className="h-screen">
          {() => (
            <>
              <ModalHeader className="flex flex-col gap-1 text-lg font-normal">
                Genereer een document
              </ModalHeader>
              <ModalBody>
                <Tabs
                  variant="underlined"
                  aria-label="Options"
                  classNames={{
                    base: "shadow-[inset_0_-1px_0_0_rgba(49,64,59,0.2)]",
                    tabList: "p-0 gap-6",
                    tab: "text-base px-0 py-0 h-fit",
                    tabContent:
                      "py-2 w-full text-neutral-secondary-mid hover:text-neutral-primary",
                  }}
                >
                  {/* <Tab key="create_template" title="Maak een nieuwe template">
                    <CreateDocumentTemplate />
                  </Tab> */}
                  <Tab
                    key="fill_template"
                    title="Vul een bestaande template in"
                  >
                    <FillDocumentTemplate />
                  </Tab>
                  {/* <Tab key="document_upload" title="Upload document">
                    <UploadDocumentTab />
                  </Tab>
                  <Tab key="create_template" title="Maak een nieuwe template">
                    <CreateTemplateTab />
                  </Tab> */}
                </Tabs>
              </ModalBody>
              <ModalFooter></ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};
